import { useCallback } from "react";
import Skeleton from "react-loading-skeleton";
import { FormTextArea } from "../../../components/forms";
import { patchReplace } from "../../../helpers/patchDoc";
import { useInstruction } from "../contexts/InstructionContext";

const CustodyBeneficiary = () => {
    const [{ patchInvest: patchInvestTrigger }, { instructionId, invest, investIsLoading }] = useInstruction();

    const patchInvest = useCallback((property, value) =>
        patchInvestTrigger({ investId: invest?.id, instructionId, operations: [patchReplace(property, value)] }).unwrap(),
        [invest?.id, instructionId, patchInvestTrigger]);

    return <span className="mt-1 row">
        {investIsLoading
            ? <Skeleton className="w-100" height={100} />
            : <FormTextArea
                label="Beneficiary"
                placeholder="Leave a comment on where/to whom the custody is being transferred (optional)"
                value={invest?.beneficiaryComment}
                onBlur={(newText) => patchInvest("beneficiaryComment", newText)}
            />}
    </span>
}

export default CustodyBeneficiary;